import React, { useContext, useState } from "react"
import { GlobalStateContext } from "../../../context/GlobalContextProvider"
import CustomPagination from "../../common/customPagination/customPagination"
import { Title } from "../../product-detail/itemDescription/styles"
import ItemCard from "../ItemCard/ItemCard"
import "./cardslist.scss"
import {
  categoriesFilterProp,
  pricesFilterProps,
} from "../../filter/filterdata"

const CardsList = (props) => {
  const {
    withoutFilter,
    courses = [],
    withSearchList,
    hasActiveFilters,
  } = props

  const [activePage, setactivePage] = useState(1)
  const itemsCount = 6

  const state = useContext(GlobalStateContext) || {}
  const {
    searchResultsCourses = [],
    selectedFilterOptions = [],
  } = state

  // Sort base courses (copy so we don't mutate props)
  const sortedCourses =
    Array.isArray(courses) && courses.length
      ? [...courses].sort((a, b) => {
        if (a.category && a.category.includes("featured")) {
          return -1
        }
        return 1
      })
      : []

  // base list: either search results or full sorted list
  let allCoursesList = withSearchList ? searchResultsCourses : sortedCourses

  // split selected filters into categories vs prices
  const selectedCategorySlugs = selectedFilterOptions.filter((opt) =>
    categoriesFilterProp.includes(opt)
  )
  const selectedPriceSlugs = selectedFilterOptions.filter((opt) =>
    pricesFilterProps.includes(opt)
  )

  // helper: convert course price into one of the price slugs we use
  const getPriceSlug = (course) => {
    const raw =
      course.product?.netFee ??
      course.product?.price ??
      course.price ??
      0

    const price = Number(raw) || 0

    if (price === 0) return "free"
    if (price >= 0 && price <= 49) return "0To49"
    if (price >= 50 && price <= 99) return "50To99"
    if (price >= 100 && price <= 499) return "100To499"
    if (price >= 500 && price <= 999) return "500To999"
    return "moreThan1000"
  }

  if (hasActiveFilters) {
    allCoursesList = allCoursesList.filter((course) => {
      // --- category filtering ---
      if (selectedCategorySlugs.length) {
        const courseCats = Array.isArray(course.category)
          ? course.category
          : [course.category]

        const matchesCategory = courseCats.some((cat) =>
          selectedCategorySlugs.includes(cat)
        )

        if (!matchesCategory) return false
      }

      // --- price filtering ---
      if (selectedPriceSlugs.length) {
        const coursePriceSlug = getPriceSlug(course)
        if (!selectedPriceSlugs.includes(coursePriceSlug)) {
          return false
        }
      }

      return true
    })
  }

  const totalRecordCount = allCoursesList.length

  const fromIndex = (activePage - 1) * itemsCount
  const toIndex = fromIndex + itemsCount
  const resultCourses = allCoursesList.slice(fromIndex, toIndex)

  const handlePageChange = (pageNumber) => {
    setactivePage(pageNumber)
  }

  return (
    <div
      className={`filterredCoursesContainer ${withoutFilter && "allcoursesContainer"
        }`}
    >
      <div>
        {withoutFilter ? (
          <Title>Courses</Title>
        ) : (
          <span className="results">
            showing <p>{totalRecordCount}</p> results
          </span>
        )}

        <div className="filteredList">
          {resultCourses.map((course) => (
            <ItemCard
              key={course.id}
              slug={course.slug}
              coverPhoto={course.coverPhoto}
              title={course.title}
              category={course.category}
              courseReference={course.courseReference}
              netFee={
                course.product?.netFee || course.product?.price
              }
              duration={course.duration}
              trainingMode={course.trainingMode || "Classroom"}
              courseRuns={course.courseRuns}
            />
          ))}
        </div>
      </div>

      <div className="pagination-main-coltainer">
        <CustomPagination
          handlePageChange={handlePageChange}
          activePage={activePage}
          Total={totalRecordCount}
          itemsCount={itemsCount}
        />
      </div>
    </div>
  )
}

export default CardsList
